import classNames from 'classnames';
import { Form, Formik, useFormikContext } from 'formik';
import i18n from '../../i18n';
import styles from '../EventSubmissionForm/EventSubmissionForm.module.scss';
import InputGroup from '../InputGroup';
import Select from 'react-select';

import inputGroupStyles from '../InputGroup/InputGroup.module.scss';

import { InputGroupV2, PrevAndSubmitButtons } from './EventSubmissionFormV2';
import { useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';

const MaybeRequiredLegend = () => {
    const { values } = useFormikContext();

    const classes = classNames(styles['EventSubmissionForm__SectionHeader'], {
        [styles['EventSubmissionForm__SectionHeader--Required']]:
            !values.isDigital,
    });

    return (
        <legend className={classes}>
            {i18n.t('EventSubmissionFormV2.sectionHeaderPlace')}
        </legend>
    );
};

const PlaceStep = ({
    initialValues,
    validationSchema,
    onClickPrev,
    onSubmit,
    venueOptions,
}) => {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleFieldChange = (e, setFieldValue) => {
        setFieldValue(e.target.name, e.target.value);
        setSelectedOption(null);
    };

    const handleDropdownChange = (selectedOption, setFieldValue) => {
        setSelectedOption(selectedOption);
        if (selectedOption) {
            setFieldValue('venueName', selectedOption.label);
            setFieldValue('address', selectedOption.address);
            setFieldValue('city', selectedOption.city);
            setFieldValue('zip', selectedOption.zipCode);
            setFieldValue('closestStation', selectedOption.closestStation);
        }
    };

    const handleVenueNameChange = (e, venueOptions, setFieldValue) => {
        const venueName = e.target.value;
        setFieldValue('venueName', venueName);

        setSelectedOption(null);

        const matchedVenue = venueOptions.find(
            (venue) => venue.label.toLowerCase() === venueName.toLowerCase()
        );

        if (matchedVenue) {
            setFieldValue('address', matchedVenue.address);
            setFieldValue('city', matchedVenue.city);
            setFieldValue('zip', matchedVenue.zipCode);
            setFieldValue('closestStation', matchedVenue.closestStation);
        }
    };

    const sortedVenueOptions = venueOptions.sort((a, b) => {
        return a.label.localeCompare(b.label);
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>
            {({ setFieldValue, values }) => (
                <Form className={styles['EventSubmissionForm--V2']}>
                    <InputGroup
                        name="isDigital"
                        type="checkbox"
                        modifiers={[inputGroupStyles['InputGroup--PlaceStep']]}
                        items={[
                            {
                                label: i18n.t(
                                    'EventSubmissionForm.labels.isDigital'
                                ),
                                name: 'isDigital',
                            },
                        ]}
                    />
                    {venueOptions.length > 0 && (
                        <>
                            <legend
                                className={
                                    styles['EventSubmissionForm__SectionHeader']
                                }>
                                {i18n.t(
                                    'EventSubmissionFormV2.sectionHeaderChooseVenue'
                                )}
                            </legend>
                            <div className={styles['EventSubmissionForm__Row']}>
                                <Dropdown
                                    options={sortedVenueOptions}
                                    value={selectedOption}
                                    onChange={(selectedOption) =>
                                        handleDropdownChange(
                                            selectedOption,
                                            setFieldValue
                                        )
                                    }
                                />
                            </div>
                        </>
                    )}
                    <MaybeRequiredLegend />

                    <InputGroupV2
                        name="venueName"
                        placeholder={i18n.t(
                            'EventSubmissionForm.placeholders.venueName'
                        )}
                        infoMessage=""
                        onChange={(e) =>
                            handleVenueNameChange(
                                e,
                                venueOptions,
                                setFieldValue
                            )
                        }
                    />

                    <div className={styles['EventSubmissionForm__Row']}>
                        <InputGroupV2
                            name="address"
                            autoComplete="off"
                            placeholder={
                                i18n.t('EventSubmissionForm.labels.address') +
                                `${!values.isDigital ? ' *' : ''}`
                            }
                            infoMessage=""
                            onChange={(e) =>
                                handleFieldChange(e, setFieldValue)
                            }
                        />
                        <InputGroupV2
                            name="zip"
                            placeholder={
                                i18n.t('EventSubmissionForm.labels.zipCode') +
                                `${!values.isDigital ? ' *' : ''}`
                            }
                            onChange={(e) =>
                                handleFieldChange(e, setFieldValue)
                            }
                        />
                    </div>
                    <InputGroupV2
                        name="city"
                        placeholder={
                            i18n.t('EventSubmissionForm.labels.city') +
                            `${!values.isDigital ? ' *' : ''}`
                        }
                        onChange={(e) => handleFieldChange(e, setFieldValue)}
                    />

                    <legend
                        className={
                            styles['EventSubmissionForm__SectionHeader']
                        }>
                        {i18n.t(
                            'EventSubmissionFormV2.sectionHeaderPlaceStation'
                        )}
                    </legend>
                    <InputGroupV2
                        name="closestStation"
                        placeholder={i18n.t(
                            'EventSubmissionForm.placeholders.closestStation'
                        )}
                        infoMessage=""
                        onChange={(e) => handleFieldChange(e, setFieldValue)}
                    />
                    <PrevAndSubmitButtons onClickPrev={onClickPrev} />
                </Form>
            )}
        </Formik>
    );
};

export default PlaceStep;
